module.exports = require("babel-polyfill");


//////////////////
// WEBPACK FOOTER
// external "babel-polyfill"
// module id = 236
// module chunks = 0